import React, { useEffect } from 'react';
import { UserDetailsForm } from '@/components/pages/SettingsPage/MainContent/shared/UserDetailsForm/UserDetailsForm';
import { analytics } from '@/analytics';
import { useUserData } from '@/components/pages/SettingsPage/MainContent/shared/useUserData';
import { Skeleton } from '@/components/ui/skeleton';

export const AccountSettings = () => {
  const { userData, isLoadingUserData } = useUserData();

  useEffect(() => {
    analytics.page({
      name: 'Account Settings',
      title: 'Settings - Account Settings',
    });
  }, []);

  if (isLoadingUserData) {
    return <Skeleton className="h-full" />;
  }

  return <UserDetailsForm userData={userData} isLoadingUserData={isLoadingUserData} />;
};
